

export default {
  locale: 'ml',
  Pagination: {
    items_per_page: '/ പേജ്',
    jump_to: 'അടുത്തത്',
    jump_to_confirm: 'ഉറപ്പാക്കുക',
    page: '',
    prev_page: 'മുൻപുള്ള പേജ്',
    next_page: 'അടുത്ത പേജ്',
    prev_5: 'മുൻപുള്ള 5 പേജുകൾ',
    next_5: 'അടുത്ത 5 പേജുകൾ',
    prev_3: 'മുൻപുള്ള 3 പേജുകൾ',
    next_3: 'അടുത്ത 3 പേജുകൾ',
    page_size: 'Page Size'
  },
  DatePicker: {
    lang: {
      placeholder: 'തിയതി തിരഞ്ഞെടുക്കുക',
      yearPlaceholder: 'വർഷം തിരഞ്ഞെടുക്കുക',
      quarterPlaceholder: 'ത്രൈമാസം തിരഞ്ഞെടുക്കുക',
      monthPlaceholder: 'മാസം തിരഞ്ഞെടുക്കുക',
      weekPlaceholder: 'വാരം തിരഞ്ഞെടുക്കുക',
      rangePlaceholder: ['ആരംഭ ദിനം', 'അവസാന ദിനം'],
      rangeYearPlaceholder: ['ആരംഭ വർഷം', 'അവസാന വർഷം'],
      rangeMonthPlaceholder: ['ആരംഭ മാസം', 'അവസാന മാസം'],
      rangeWeekPlaceholder: ['ആരംഭ വാരം', 'അവസാന വാരം'],
      locale: 'ml_IN',
      today: 'ഇന്ന്',
      now: 'ഇപ്പോൾ',
      backToToday: 'ഇന്നത്തെ ദിവസത്തിലേക്ക് തിരിച്ചു പോകുക',
      ok: 'ശരിയാണ്',
      clear: 'നീക്കം ചെയ്യുക',
      month: 'മാസം',
      year: 'വർഷം',
      timeSelect: 'സമയം തിരഞ്ഞെടുക്കുക',
      dateSelect: 'ദിവസം തിരഞ്ഞെടുക്കുക',
      weekSelect: 'വാരം തിരഞ്ഞെടുക്കുക',
      monthSelect: 'മാസം തിരഞ്ഞെടുക്കുക',
      yearSelect: 'വർഷം തിരഞ്ഞെടുക്കുക',
      decadeSelect: 'ദശാബ്ദം തിരഞ്ഞെടുക്കുക',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'കഴിഞ്ഞ മാസം (PageUp)',
      nextMonth: 'അടുത്ത മാസം (PageDown)',
      previousYear: 'കഴിഞ്ഞ വർഷം (Control + left)',
      nextYear: 'അടുത്ത വർഷം (Control + right)',
      previousDecade: 'കഴിഞ്ഞ ദശാബ്ദം',
      nextDecade: 'അടുത്ത ദശാബ്ദം',
      previousCentury: 'കഴിഞ്ഞ നൂറ്റാണ്ട്',
      nextCentury: 'അടുത്ത നൂറ്റാണ്ട്'
    },
    timePickerLocale: {
      placeholder: 'സമയം തിരഞ്ഞെടുക്കുക',
      rangePlaceholder: ['ആരംഭ സമയം', 'അവസാന സമയം']
    }
  },
  TimePicker: {
    placeholder: 'സമയം തിരഞ്ഞെടുക്കുക',
    rangePlaceholder: ['ആരംഭ സമയം', 'അവസാന സമയം']
  },
  Calendar: {
    lang: {
      placeholder: 'തിയതി തിരഞ്ഞെടുക്കുക',
      yearPlaceholder: 'വർഷം തിരഞ്ഞെടുക്കുക',
      quarterPlaceholder: 'ത്രൈമാസം തിരഞ്ഞെടുക്കുക',
      monthPlaceholder: 'മാസം തിരഞ്ഞെടുക്കുക',
      weekPlaceholder: 'വാരം തിരഞ്ഞെടുക്കുക',
      rangePlaceholder: ['ആരംഭ ദിനം', 'അവസാന ദിനം'],
      rangeYearPlaceholder: ['ആരംഭ വർഷം', 'അവസാന വർഷം'],
      rangeMonthPlaceholder: ['ആരംഭ മാസം', 'അവസാന മാസം'],
      rangeWeekPlaceholder: ['ആരംഭ വാരം', 'അവസാന വാരം'],
      locale: 'ml_IN',
      today: 'ഇന്ന്',
      now: 'ഇപ്പോൾ',
      backToToday: 'ഇന്നത്തെ ദിവസത്തിലേക്ക് തിരിച്ചു പോകുക',
      ok: 'ശരിയാണ്',
      clear: 'നീക്കം ചെയ്യുക',
      month: 'മാസം',
      year: 'വർഷം',
      timeSelect: 'സമയം തിരഞ്ഞെടുക്കുക',
      dateSelect: 'ദിവസം തിരഞ്ഞെടുക്കുക',
      weekSelect: 'വാരം തിരഞ്ഞെടുക്കുക',
      monthSelect: 'മാസം തിരഞ്ഞെടുക്കുക',
      yearSelect: 'വർഷം തിരഞ്ഞെടുക്കുക',
      decadeSelect: 'ദശാബ്ദം തിരഞ്ഞെടുക്കുക',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'കഴിഞ്ഞ മാസം (PageUp)',
      nextMonth: 'അടുത്ത മാസം (PageDown)',
      previousYear: 'കഴിഞ്ഞ വർഷം (Control + left)',
      nextYear: 'അടുത്ത വർഷം (Control + right)',
      previousDecade: 'കഴിഞ്ഞ ദശാബ്ദം',
      nextDecade: 'അടുത്ത ദശാബ്ദം',
      previousCentury: 'കഴിഞ്ഞ നൂറ്റാണ്ട്',
      nextCentury: 'അടുത്ത നൂറ്റാണ്ട്'
    },
    timePickerLocale: {
      placeholder: 'സമയം തിരഞ്ഞെടുക്കുക',
      rangePlaceholder: ['ആരംഭ സമയം', 'അവസാന സമയം']
    }
  },
  global: {
    placeholder: 'ദയവായി തിരഞ്ഞെടുക്കുക'
  },
  Table: {
    filterTitle: 'ഫിൽറ്റർ',
    filterConfirm: 'ശരിയാണ്',
    filterReset: 'പുനഃക്രമീകരിക്കുക',
    filterEmptyText: 'ഫിൽറ്ററുകളൊന്നുമില്ല',
    emptyText: 'ഡാറ്റയൊന്നുമില്ല',
    selectAll: 'നിലവിലെ പേജ് തിരഞ്ഞെടുക്കുക',
    selectInvert: 'നിലവിലെ പേജിൽ ഇല്ലാത്തത് തിരഞ്ഞെടുക്കുക',
    selectNone: 'എല്ലാ ഡാറ്റയും നീക്കം ചെയ്യുക',
    selectionAll: 'എല്ലാ ഡാറ്റയും തിരഞ്ഞെടുക്കുക',
    sortTitle: 'ക്രമമാക്കുക',
    expand: 'വരി വികസിപ്പിക്കുക',
    collapse: 'വരി ചുരുക്കുക',
    triggerDesc: 'അവരോഹണ ക്രമത്തിനായി ക്ലിക്ക് ചെയ്യുക',
    triggerAsc: 'ആരോഹണ ക്രമത്തിനായി ക്ലിക്ക് ചെയ്യുക',
    cancelSort: 'ക്രമീകരണം ഒഴിവാക്കുന്നതിനായി ക്ലിക്ക് ചെയ്യുക'
  },
  Modal: {
    okText: 'ശരിയാണ്',
    cancelText: 'റദ്ദാക്കുക',
    justOkText: 'ശരിയാണ്'
  },
  Popconfirm: {
    okText: 'ശരിയാണ്',
    cancelText: 'റദ്ദാക്കുക'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'ഇവിടെ തിരയുക',
    itemUnit: 'ഇനം',
    itemsUnit: 'ഇനങ്ങൾ',
    remove: 'നീക്കം ചെയ്യുക',
    selectCurrent: 'നിലവിലെ പേജ് തിരഞ്ഞെടുക്കുക',
    removeCurrent: 'നിലവിലെ പേജ് നീക്കം ചെയ്യുക',
    selectAll: 'എല്ലാ ഡാറ്റയും തിരഞ്ഞെടുക്കുക',
    removeAll: 'എല്ലാ ഡാറ്റയും നീക്കം ചെയ്യുക',
    selectInvert: 'നിലവിലെ പേജിൽ ഇല്ലാത്തത് തിരഞ്ഞെടുക്കുക'
  },
  Upload: {
    uploading: 'അപ്‌ലോഡ് ചെയ്തു കൊണ്ടിരിക്കുന്നു...',
    removeFile: 'ഫയൽ നീക്കം ചെയ്യുക',
    uploadError: 'അപ്‌ലോഡിൽ പിശക് സംഭവിച്ചിരിക്കുന്നു',
    previewFile: 'ഫയൽ പ്രിവ്യൂ ചെയ്യുക',
    downloadFile: 'ഫയൽ ഡൗൺലോഡ് ചെയ്യുക'
  },
  Empty: {
    description: 'ഡാറ്റയൊന്നുമില്ല'
  },
  Icon: {
    icon: 'ഐക്കൺ'
  },
  Text: {
    edit: 'തിരുത്തുക',
    copy: 'കോപ്പി ചെയ്യുക',
    copied: 'കോപ്പി ചെയ്തു',
    expand: 'വികസിപ്പിക്കുക'
  },
  PageHeader: {
    back: 'തിരികെ'
  },
  Image: {
    preview: 'പ്രിവ്യൂ'
  }
};
